import { useEffect, useState } from "react";
import DashboardLayout from "../Layouts/DashboardLayout";

export default function RawMaterialUsage() {
  const [usage, setUsage] = useState([]);

  useEffect(() => {
    fetchUsage();
  }, []);

  const fetchUsage = async () => {
    try {
      const res = await fetch("/api/production/usage", {
        credentials: "include",
      });

      const data = await res.json();

      if (data.status === "success") {
        setUsage(data.data);
      }
    } catch (err) {
      console.error("Usage fetch error:", err);
    }
  };

  return (
    <DashboardLayout>
      <div className="space-y-8">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-serif">Raw Material Usage</h1>
        </div>

        <div className="rounded-2xl bg-white/5 border border-white/10 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-black/40 text-gray-400">
              <tr>
                <th className="px-6 py-4 text-left">Batch</th>
                <th className="px-6 py-4">Product</th>
                <th className="px-6 py-4">Material</th>
                <th className="px-6 py-4">Quantity Used</th>
                <th className="px-6 py-4">Date</th>
              </tr>
            </thead>

            <tbody>
              {usage.length === 0 ? (
                <tr>
                  <td
                    colSpan="5"
                    className="text-center p-6 text-gray-500"
                  >
                    No usage found
                  </td>
                </tr>
              ) : (
                usage.map((u, i) => (
                  <tr
                    key={i}
                    className="border-t border-white/10 hover:bg-white/5"
                  >
                    <td className="px-6 py-4">{u.batch}</td>
                    <td className="px-6 py-4 text-center">{u.product}</td>
                    <td className="px-6 py-4 text-center">{u.material}</td>
                    <td className="px-6 py-4 text-center">
                      {u.quantity} {u.unit}
                    </td>
                    <td className="px-6 py-4 text-center">
                      {new Date(u.date).toLocaleDateString()}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}